import { DEFAULT_SECTIONS, ProductTypeConfig } from '../types';

/**
 * 1200 - Discount Certificate
 *
 * At a glance: Quotation Type, Issue price %, Max yield %, Max yield p.a %, Discount %, Strike %, Settlement type
 * Barrier: Deshabilitada
 * Underlying: Strike (mantener cálculos existentes, sin Barrier level ni Barrier distance)
 * Performance: Default
 */
export const config1200: ProductTypeConfig = {
  code: '1200',
  name: 'Discount Certificate',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false,
        quotationType: true,
        issuePricePct: false,
        maxYieldPct: true,
        maxYieldPaPct: true,
        discountPct: true,
        strike: true,
        settlementType: true,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: false,
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        strikeLevel: true,
        strikeDistance: true,
        barrierLevel: false,
        barrierDistance: false,
      },
    },

    coupons: {
      ...DEFAULT_SECTIONS.coupons,
      enabled: false,
    },

    earlyRedemption: {
      ...DEFAULT_SECTIONS.earlyRedemption,
      enabled: false,
    },

    performance: {
      ...DEFAULT_SECTIONS.performance,
      enabled: true,
    },
  },
};
